const newsTopic = [
  'Crypto',
  'Cryptocurrencies',
  'Cryptocurrency',
  'Altcoin',
  'Blockchain',
  'Cold wallet',
  'Hot Wallet',
  'Decentralization',
  'DeFi',
  'DApps',
  'Digital Gold',
  'HODL',
  'Initial Coin Offering',
  'NFT',
  'Satoshi Nakomoto',
  'Vitalik Buterin',
  'Smart Contract',
  'Stablecoin',
  'Digital Fiat',
  'Dead coin',
  'DAO',
  'ERC-20',
  'Etherscan',
  'Flippening',
  'Memecoin',
  'Mimblewimble',
  'Mining rigs',
  'Pump and dump',
  'Rugpull',
  'Wallet seed phrase',
  'Wallet address',
  'Digital currency',
  '51% Attack',
  'ETH gas fee',
  'Coingecko',
  'Coinbase',
  'Ronin bridge',
  'Metamask',
  'Crypto.com',
  'WhiteBIT',
  'Binance',
  'PancakeSwap',
  'Uniswap',
  'Web3',
  'Block Reward',
  'Gwei',
  'Hashrate',
  'Mainnet',
  'Proof of stake',
  'Proof of work',
  'Scrypt',
  'Utility token',
  'Token Generation Event',
  'Shielded Transactions',
  'Ox Protocol',
  'Accounting Token',
  'Aeternity BlockChain',
  'Airnode',
  'Algorithmic Stablecoin',
  'Apeing',
  'Arbitrage',
  'Asset-Backed Tokens',
  'Block Height',
  'Mempool',
  'Non-Fungible Token',
  'Chain Linking',
  'The Flippening',
  'Casascius Coin',
  'Coin mixer',
  'Double Spend',
  'Crypto FOMO',
  'Crypto FUD',
  'Nick Szabo',
  'Craig Wright',
  'Brian Armstrong',
  'White Paper',
  'Escrow',
  'Mining Farm',
  'Multichain',
  'OpenSea',
  'Scamcoin',
  'Sharding',
  'Silk Road',
  'Vanity Address',
  'Vaporware',
  'Crypto Whitelist',
  'Fiat Currencies',
  'Initial Exchange Offering',
  'Mining Incentive',
  'Light node',
  'Liquid Staking',
  'Liquidity Pool',
  'Master Node',
  'Crypto Metaverse',
  'Crypto Minting',
  'Recovery Seed',
  'Uni Token',
  'Enterprise Blockchain',
  'Crypto Dark Web',
  'Dead Coin',
  'Decentralized Currency',
  'Decentralized Exchange',
  'DeFi Degens',
  'Fan Token',
  'Bitcoin',
  'Ethereum',
  'Tether',
  'Binancecoin',
  'Usd-Coin',
  'Solana',
  'Terra-Luna',
  'Ripple',
  'Cardano',
  'Dogecoin',
  'Terrausd',
  'Polkadot',
  'Avalanche-2',
  'Binance-Usd',
  'Shiba-Inu',
  'Wrapped-Bitcoin',
  'Staked-Ether',
  'Crypto-Com-Chain',
  'Dai',
  'Matic-Network',
  'Near',
  'Bonded-Luna',
  'Litecoin',
  'Tron',
  'Apecoin',
  'Cosmos',
  'Bitcoin-Cash',
  'Chainlink',
  'Ftx-Token',
  'Leo-Token',
  'Okb',
  'Stellar',
  'Algorand',
  'Monero',
  'Ethereum-Classic',
  'Uniswap',
  'Filecoin',
  'Hedera-Hashgraph',
  'Vechain',
  'Internet-Computer',
  'Elrond-Erd-2',
  'Magic-Internet-Money',
  'The-Sandbox',
  'Compound-Ether',
  'Axie-Infinity',
  'Frax',
  'Theta-Token',
  'Decentraland',
  'The-Graph',
  'Tezos',
  'Fantom',
  'Stepn',
  'Klay-Token',
  'Pancakeswap-Token',
  'Eos',
  'Defichain',
  'Aave',
  'Thorchain',
  'Theta-Fuel',
  'Kucoin-Shares',
  'Flow',
  'Zcash',
  'Iota',
  'Bittorrent',
  'Convex-Finance',
  'Frax-Share',
  'Osmosis',
  'Nexo',
  'Compound-Usd-Coin',
  'Helium',
  'Huobi-Btc',
  'Ecash',
  'Waves',
  'Bitcoin-Cash-Sv',
  'Huobi-Token',
  'Maker',
  'Kusama',
  'True-Usd',
  'Cdai',
  'Chain-2',
  'Quant-Network',
  'Neo',
  'Arweave',
  'Gala',
  'Zilliqa',
  'Havven',
  'Radix',
  'Enjincoin',
  'Celo',
  'Bitdao',
  'Harmony',
  'Blockstack',
  'Lido-Dao',
  'Chiliz',
  'Dash',
  'Loopring',
  'Paxos-Standard',
  'Amp-Token',
  'Maiar-Dex',
  'Kava',
  'Gatechain-Token',
  'Basic-Attention-Token',
  'Neutrino',
  'Mina-Protocol',
  'Curve-Dao-Token',
  'Celsius-Degree-Token',
  'Decred',
  'Nem',
  'Compound-Governance-Token',
  'Kadena',
  'Compound-Usdt',
  'Holotoken',
  'Link',
  'Secret',
  'Oasis-Network',
  'Xdce-Crowd-Sale',
  'Nxm',
  '0X',
  'Ecomi',
  'Msol',
  'Iotex',
  'Moonbeam',
  'Yearn-Finance',
  'Audius',
  'Juno-Network',
  'Gnosis',
  'Qtum',
  'Pax-Gold',
  'Skale',
  'Anchor-Protocol',
  'Iostoken',
  'Oec-Token',
  'Livepeer',
  'Xido-Finance',
  'Sapphire',
  'Bancor',
  'Omisego',
  'Fei-Usd',
  'Ankr',
  'Bitkub-Coin',
  'Sushi',
  'Kyber-Network-Crystal',
  'Icon',
  'Dogelon-Mars',
  'Serum',
  'Bitcoin-Gold',
  'Synapse-2',
  '1Inch',
  'Swipe',
  'Smooth-Love-Potion',
  'Rocket-Pool',
  'Ravencoin',
  'Convex-Crv',
  'Astar',
  'Wax',
  'Liquity-Usd',
  'Just',
  'Siacoin',
  'Tether-Gold',
  'Pocket-Network',
  'Constellation-Labs',
  'Songbird',
  'Velas',
  'Ontology',
  'Olympus',
  'Everscale',
  'Nucypher',
  'Apenft',
  'Renbtc',
  'Ethereum-Name-Service',
  'Rally-2',
  'Woo-Network',
  'Dydx',
  'Acala',
  'Zencash',
  'Swissborg',
  'Astroport',
  'Golem',
  'Immutable-X',
  'Everdome',
  'Trust-Wallet-Token',
  'Radio-Caca',
  'Looksrare',
  'Uma',
  'Render-Token',
  'Polymath',
  'Plex',
  'Vvs-Finance',
  'Baby-Doge-Coin',
  'Republic-Protocol',
  'Safemoon-2',
  'Syscoin',
  'Hive',
  'Zelcash',
  'Digibyte',
  'Lido-Staked-Sol',
  'Husd',
  'Titanswap',
  'Illuvium',
  'Zoid-Pay',
  'Mobox',
  'Spell-Token',
  'Bitclout',
  'Nervos-Network',
  'Ceek',
  'Telcoin',
  'Pirate-Chain',
  'Flex-Coin',
  'Playdapp',
  'Mimatic',
  'Casper-Network',
  'Tomb',
  'Biswap',
  'Lisk',
  'Maple',
  'Safemoon',
  'Kyber-Network',
  'Dao-Maker',
  'Keep-Network',
  'Mxc',
  'Wink',
  'Tenset',
  'Conflux-Token',
  'Wazirx',
  'Zipmex-Token',
  'Coin98',
  'Nano',
  'Persistence',
  'Raydium',
  'Mx-Token',
  'Perpetual-Protocol',
  'Origin-Protocol',
  'E-Radix',
  'Status',
  'Injective-Protocol',
  'Coinex-Token',
  'Chia',
  'Chromaway',
  'Ultra',
  'Escoin-Token',
  'Vulcan-Forged',
  'Tribe-2',
  'Celer-Network',
  'Constitutiondao',
  'Digitalbits',
  'Yusd-Stablecoin',
  'Fx-Coin',
  'Staked-Luna',
  'Orbs',
  'Medibloc',
  'Coti',
  'Benqi-Liquid-Staked-Avax',
  'Pundi-X-2',
  'Dent',
  'Tether-Eurt',
  'Gmx',
  'Holoride',
  'Joe',
  'Mask-Network',
  'Ardor',
  'Civic',
  'Xsushi',
  'Api3',
  'Xyo-Network',
  'Gemini-Dollar',
  'Power-Ledger',
  'Fetch-Ai',
  'Ocean-Protocol',
  'Dopex',
  'Aurora-Near',
  'Divi',
  'Steem',
  'Creditcoin-2',
  'Tokemak',
  'Defi-Kingdoms',
  'Ergo',
  'Moonriver',
  'Alchemix-Usd',
  'Energy-Web-Token',
  'Sifchain',
  'Cratos',
  'Klever',
  'Merit-Circle',
  'Telos',
  'Milk-Alliance',
  'Reserve-Rights-Token',
  'Railgun',
  'Lukso-Token',
  'Meerkat-Shares',
  'Usdx',
  'Metis-Token',
  'Ronin',
  'Radicle',
  'Akash-Network',
  'Mirror-Protocol',
  'Multichain',
  'Yield-Guild-Games',
  'Metal',
  'Cartesi',
  'Mdex',
  'Seth2',
  'Bnb48-Club-Token',
  'Insure',
  'Origintrail',
  'Boba-Network',
  'Floki-Inu',
  'Tokamak-Network',
  'Mmfinance',
  'Vethor-Token',
  'Dero',
  'Request-Network',
  'League-Of-Kingdoms',
  'Ark',
  'Ufo-Gaming',
  'Xsgd',
  'Balancer',
  'Storm',
  'Btse-Token',
  'Reef-Finance',
  'Rari-Governance-Token',
  'Bifrost',
  'Verge',
  'Numeraire',
  'Hxro',
  'Sun-Token',
  'Aragon',
  'Band-Protocol',
  'Aelf',
  'Storj',
  'Alpha-Finance',
  'Flex-Usd',
  'Biconomy',
  'Asd',
  'Superfarm',
  'Prometeus',
  'Metahero',
  'Ankreth',
  'Stratis',
  'Beldex',
  'Bakerytoken',
  'Keep3Rv1',
  'Weway',
  'Bezoge-Earth',
  'Stasis-Eurs',
  'Quark-Chain',
  'Stp-Network',
  'Beta-Finance',
  'Ellipsis',
  'Orchid-Protocol',
  'Maidsafecoin',
  'Mango-Markets',
  'Truefi',
  'Dawn-Protocol',
  'Sperax',
  'Iexec-Rlc',
  'Poollotto-Finance',
  'Metadium',
  'Venus',
  'Iron-Bank-Euro',
  'Alchemy-Pay',
  'Strike',
  'Kirobo',
  'Shiba-Predator',
  'Nkn',
  'Yoshi-Exchange',
  'Tomochain',
  'Nusd',
  'Interest-Bearing-Bitcoin',
  'Gpex',
  'Dei-Token',
  'Rif-Token',
  'Adshares',
  'Kishu-Inu',
  'Gensokishis-Metaverse',
  'Gxchain',
  'Victoria-Vr',
  'Tomb-Shares',
  'Dodo',
  'Aavegotchi',
  'Dopex-Rebate-Token',
  'Funfair',
  'My-Neighbor-Alice',
  'Alien-Worlds',
  'Kava-Swap',
  'Hoo-Token',
  'Deapcoin',
  'Beefy-Finance',
  'Polkastarter',
  'World-Mobile-Token',
  'Utrust',
  'Btc-Standard-Hashrate-Token',
  'Dusk-Network',
  'Platon-Network',
  'Everipedia',
  'Propy',
  'Qredo',
  'Ampleforth',
  'Kardiachain',
  'Xcad-Network',
  'Coinmetro',
  'Kilt-Protocol',
  'Sbtc',
  'Butterflydao',
  'Platoncoin',
  'Hermez-Network-Token',
  'Decentral-Games',
  'Rmrk',
  'Compound-Basic-Attention-Token',
  'Wonderland',
  'Hydra',
  'Origin-Dollar',
  'Seedify-Fund',
  'Marlin',
  'Singularitynet',
  'Augur',
  'Orion-Protocol',
  'Xmon',
  'Jasmycoin',
  'Veritaseum',
  'Feg-Token-Bsc',
  'Auction',
  'Aioz-Network',
  'Linear',
  'Unibright',
  'Hunt-Token',
  'Dash-Diamond',
  'Electroneum',
  'Aergo',
  'Alchemix',
  'Gains-Farm',
  'Proton',
  'Shapeshift-Fox-Token',
  'Starlink',
  'Tornado-Cash',
  'E-Money',
  'Covalent',
  'Aurora-Dao',
  'Thunder-Token',
  'Wrapped-Centrifuge',
  'Savanna',
  'Seth',
  'Bitrue-Token',
  'Compound-0X',
  'Ethlend',
  'Feg-Token',
  'Wanchain',
  'Badger-Dao',
  'Compound-Uniswap',
  'Dvision-Network',
  'Hathor',
  'Wilder-World',
  'Certik',
  'Blox',
  'Neutrino-System-Base-Token',
  'Cocos-Bcx',
  'Melon',
  'Quick',
  'Ageur',
  'Stargaze',
  'Wrapped-Nxm',
  'Nerve-Finance',
  'Karura',
  'Adventure-Gold',
  'Jpeg-D',
  'Clover-Finance',
  'Automata',
  'Gitcoin',
  'Allianceblock',
  'Safepal',
  'Regen',
  'Defipulse-Index',
  'Spookyswap',
  'Klima-Dao',
  'Rook',
  'Alpaca-Finance',
  'Superrare',
  'Mainframe',
  'Umee',
  'Darkcrypto-Share',
  'Sai',
  'Aurory',
  'Celo-Dollar',
  'Everrise',
  'Carry',
  'Cvault-Finance',
  'Dock',
  'Sharering',
  'Uquid-Coin',
  'Verasity',
  'Eth-2X-Flexible-Leverage-Index',
  'Pylon-Protocol',
  'Nym',
  'Chainx',
  'Temple',
  'Marketpeak',
  'Rizon',
  'Meter',
  'X2Y2',
  'District0X',
  'Loom-Network',
];

export default newsTopic;